"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _reactVis = require("react-vis");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styles = require("../styles");

var _ResizableXYPlot = _interopRequireDefault(require("./ResizableXYPlot"));

var _colors = require("../constants/colors");

var _HintDateRange = _interopRequireDefault(require("./HintDateRange"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HintBody = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);\n  color: ", ";\n  padding: 15px 20px;\n"])), _colors.WHITE, _colors.NAVY);

var Wrapper = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 15;\n  margin-top: 20px;\n  margin-right: 30px;\n  margin-bottom: 20px;\n"])));

var Label = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  border: 2px solid ", ";\n  bottom: 0;\n  display: flex;\n  font-size: 8px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 40px;\n"])), _colors.RED);

var AlertName = _styled["default"].strong(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 10px;\n"])));

var hintWidth = 200;

var AlertHistoryChart = function AlertHistoryChart(_ref) {
  var alerts = _ref.alerts,
      viewStartISO = _ref.viewStartISO,
      viewEndISO = _ref.viewEndISO,
      zone = _ref.zone;

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: zone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: zone
  });

  var coordinates = (0, _react.useMemo)(function () {
    return alerts.sort(function (a, b) {
      return a.createdDateUTC > b.createdDateUTC ? 1 : -1;
    }).filter(function (a) {
      return a.createdDateUTC;
    }).map(function (a) {
      var closedDate = _luxon.DateTime.fromISO(a.closedDateUTC, {
        zone: zone
      });

      var x;

      if (closedDate.isValid) {
        x = closedDate.toMillis();
      } else {
        x = _luxon.DateTime.fromJSDate(new Date(), {
          zone: zone
        }).startOf('day').toMillis();
      }

      return _objectSpread({
        x0: _luxon.DateTime.fromISO(a.createdDateUTC, {
          zone: zone
        }).toMillis(),
        x: x,
        y0: 0,
        y: 15
      }, a);
    });
  }, [alerts, zone]);

  var wrapperEl = /*#__PURE__*/_react["default"].createRef();

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCoordinate = _useState2[0],
      setSelectedCoordinate = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      cursorX = _useState4[0],
      setCursorX = _useState4[1];

  var _useState5 = (0, _react.useState)('right'),
      _useState6 = _slicedToArray(_useState5, 2),
      cursorAlignment = _useState6[0],
      setCursorAlignment = _useState6[1];

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    ref: wrapperEl
  }, /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dataTestid: "alert-history-chart",
    height: 15,
    margin: {
      top: 0,
      left: 70,
      right: 0,
      bottom: 0
    },
    style: {
      background: _colors.GREEN
    },
    onMouseMove: function onMouseMove(e) {
      // Cursor X needs to be relative to the wrapper
      var rect = wrapperEl.current.getBoundingClientRect();
      var clientX = e.clientX;
      setCursorX(clientX - rect.x);
      var halfwayX = rect.x + rect.width / 2;

      if (clientX < halfwayX) {
        setCursorAlignment('right');
      } else {
        setCursorAlignment('left');
      }
    },
    onMouseLeave: function onMouseLeave() {
      return setSelectedCoordinate(null);
    },
    xDomain: [viewStartDateTime.toMillis(), viewEndDateTime.toMillis()],
    dontCheckIfEmpty: true
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalRectSeries, {
    colorType: "literal",
    data: coordinates,
    getColor: function getColor(c) {
      return "#".concat(c.color);
    },
    onValueMouseOver: function onValueMouseOver(c) {
      return setSelectedCoordinate(c);
    },
    onValueMouseOut: function onValueMouseOut() {
      return setSelectedCoordinate(null);
    }
  }), selectedCoordinate && /*#__PURE__*/_react["default"].createElement(_reactVis.Hint, {
    getAlignStyle: function getAlignStyle() {
      return cursorAlignment === 'right' ? {
        left: cursorX
      } : {
        left: cursorX - hintWidth
      };
    },
    value: selectedCoordinate
  }, /*#__PURE__*/_react["default"].createElement(HintBody, null, /*#__PURE__*/_react["default"].createElement(AlertName, null, selectedCoordinate.name), /*#__PURE__*/_react["default"].createElement(_HintDateRange["default"], {
    coordinate: selectedCoordinate,
    zone: zone
  }))), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _styles.borderStyle
  })), /*#__PURE__*/_react["default"].createElement(Label, null, "ALERTS"));
};

AlertHistoryChart.propTypes = {
  alerts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    color: _propTypes["default"].string,
    casePriority: _propTypes["default"].number,
    caseReason: _propTypes["default"].string,
    closedDateUTC: _propTypes["default"].string,
    createdDateUTC: _propTypes["default"].string,
    currentSeverity: _propTypes["default"].number,
    intRef: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string
};
AlertHistoryChart.defaultProps = {
  alerts: [],
  zone: 'local'
};
var _default = AlertHistoryChart;
exports["default"] = _default;